// extracted by mini-css-extract-plugin
module.exports = {"profilePane":"styles_profilePane__3FLqH","changePassModalContent":"styles_changePassModalContent__1TOwa","loginInfo":"styles_loginInfo__97Tq6"};